import React from 'react'

// Tells plan components that they are rendered inside the review drawer (read-only mode, scroll to the reviewed item).
// Redux can't answer this: the same plan tree is also rendered on the page behind the drawer.
export const ReviewDrawerContext = React.createContext<boolean>(false)
